module.exports = __webpack_public_path__ + "static/media/24.bb6f4f7a.mp3";